import React, { useEffect, useState } from 'react';
import { FlameIcon, ClockIcon } from 'lucide-react';
export function StickyUrgencyBar() {
  // 2 hours in seconds
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-danger text-white py-3 px-4 shadow-lg border-b border-red-900/50" data-id="element-322">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm sm:text-base font-medium text-center" data-id="element-323">
        <div className="flex items-center gap-2 text-accent font-bold tracking-wide" data-id="element-324">
          <FlameIcon className="w-5 h-5 animate-pulse" data-id="element-325" />
          <span data-id="element-326">OFERTA DE LANZAMIENTO: 90% DE DESCUENTO</span>
        </div>

        <div className="hidden sm:block w-px h-4 bg-white/20" data-id="element-327"></div>

        <div className="flex items-center gap-2" data-id="element-328">
          <span data-id="element-329">Obtén el Bundle "Sculpt-It" por solo $9.99 USD</span>
          <span className="opacity-60 line-through text-xs hidden md:inline" data-id="element-330">
            ($97)
          </span>
        </div>

        <div className="hidden sm:block w-px h-4 bg-white/20" data-id="element-331"></div>

        <div className="flex items-center gap-2 font-mono bg-black/30 px-3 py-1 rounded-md border border-white/10" data-id="element-332">
          <ClockIcon className="w-4 h-4 text-accent" data-id="element-333" />
          <span className="tracking-wider" data-id="element-334">{formatTime(timeLeft)}</span>
        </div>
      </div>
    </div>;
}